/* eslint-disable */
const groupSet = {
  currentGroupSetPrice: 0,
  format_0(data) {
    const res = [];
    for (const item of data) {
      let product = [];
      if (item.mains) {
        for (const main of item.mains) {
          product = product.concat(this.format_1(main));
        }
      }
      if (item.exArea && Object.keys(item.exArea).length > 0) {
        product = product.concat(this.format_1(item.exArea));
      }
      res.push(product);
    }
    return res;
  },
  format_1(data) {
    const res = [];
    for (const group of data.groups) {
      res = res.concat(this.format_2(group));
    }
    return res;
  },
  format_2(data) {
    const res = [];
    for (const product of data.products) {
      this.currentGroupSetPrice += product.num * data.price;
      res.push({
        name: product.name,
        price: product.price,
        num: product.num,
        listPropertys: product.listPropertys ? this.format_3(product.listPropertys) : [],
      });
    }
    return res;
  },
  format_3(datas) {
    if (!datas) return [];

    const arr = [];
    for (const data of datas) {
      const el = {
        index: data.index,
        propertys: [],
      };
      for (const prop of data.propertys) {
        for (const item of prop.items) {
          el.propertys.push({
            name: item.name,
            num: item.num || 1,
            price: item.price,
          });
        }
      }
      if (el.propertys.length) arr.push(el);
    }
    return arr;
  },
};

export default {
  groupSet,
};
